export default __webpack_public_path__ + "static/media/img3.af9fa5ee.jpg";